"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.registerOrAuthorizeByToken = registerOrAuthorizeByToken;
var _phoneAuth = require("../../types/phoneAuth");
var _action_types = require("../../constants/action_types");
var _registerOrAuthorizeUserByToken = require("../../repositories/users/v1/register-or-authorize-user-by-token");
var _jsonpRequest = require("../../../browser/utils/jsonpRequest");
var _ = require("../../..");
var _tracking = require("../../utils/tracking");
var _view = require("../view");
var _rememberedAccounts = require("../../utils/rememberedAccounts");
var _rememberedAccounts2 = require("../../types/rememberedAccounts");
var _formatString = require("../../utils/formatString");
function registerOrAuthorizeByToken() {
  return async (dispatch, getState, context) => {
    dispatch({
      status: _phoneAuth.ERegisterOrAuthByTokenStatus.Loading,
      type: _action_types.PHONE_AUTH_REGISTER_OR_AUTHORIZE_BY_TOKEN_TYPE
    });
    const {
      view,
      phoneAuth: {
        phone,
        registerOrAuth,
        sendValidationCode: {
          senderType
        }
      },
      agreement: {
        licenceAccepted,
        marketingSubscriptionAccepted
      },
      isRememberAccountsFlow,
      source
    } = getState();
    try {
      const res = await (0, _registerOrAuthorizeUserByToken.fetchRegisterOrAuthorizeUserByToken)({
        httpApi: context.httpApi,
        parameters: {
          temporaryToken: registerOrAuth.temporaryToken,
          isAcceptLicence: licenceAccepted,
          hasMarketingSubscriptions: marketingSubscriptionAccepted
        },
        config: {
          requestConfig: {
            headers: [['Content-Type', 'application/json']],
            withCredentials: true
          }
        }
      });
      if (res.statusCode === 200) {
        const {
          isRegistered,
          logOnUrl,
          token,
          email
        } = res.response;
        try {
          await (0, _jsonpRequest.jsonpRequest)(`${logOnUrl}?login=${encodeURIComponent(email)}&token=${token}&persistent=true`);
          dispatch({
            status: _phoneAuth.ERegisterOrAuthByTokenStatus.Succeed,
            type: _action_types.PHONE_AUTH_REGISTER_OR_AUTHORIZE_BY_TOKEN_TYPE
          });
          if (isRegistered) {
            context.emitter.emit(_.EEventType.RegisterSucceed, {
              email,
              phone,
              senderType
            });
            (0, _tracking.trackRegistrationSuccess)({
              senderType,
              source
            });
          } else {
            context.emitter.emit(_.EEventType.AuthenticateSucceed, {
              email,
              phone,
              senderType
            });
            (0, _tracking.trackAuthenticateSuccess)({
              senderType,
              source
            });
          }
          if (isRememberAccountsFlow) {
            (0, _rememberedAccounts.saveAccount)({
              type: _rememberedAccounts2.ERememberedAccountType.Phone,
              value: (0, _formatString.formatPhoneWithSpecialChars)(phone)
            });
          }
        } catch (e) {
          context.logger.error(e, {
            domain: 'auth-widget.api.registerOrAuthorizeByToken#logon'
          });
          dispatch({
            type: _action_types.PHONE_AUTH_REGISTER_OR_AUTHORIZE_BY_TOKEN_TYPE,
            status: _phoneAuth.ERegisterOrAuthByTokenStatus.Failed,
            error: 'Произошла непредвиденная ошибка'
          });
        }
      } else if (res.statusCode === 400 && res.response.errors.some(error => error.code.includes('tokenExpired'))) {
        dispatch({
          type: _action_types.PHONE_AUTH_REGISTER_OR_AUTHORIZE_BY_TOKEN_TYPE,
          status: _phoneAuth.ERegisterOrAuthByTokenStatus.Failed,
          error: res.response.message
        });
        dispatch((0, _view.changeView)(_.EActiveView.TokenExpiredError));
      } else if (res.statusCode === 400 && res.response.errors.some(error => error.code.includes('LicenceDoesNotAccepted'))) {
        dispatch({
          type: _action_types.PHONE_AUTH_REGISTER_OR_AUTHORIZE_BY_TOKEN_TYPE,
          status: _phoneAuth.ERegisterOrAuthByTokenStatus.Succeed
        });
        dispatch((0, _view.changeView)(_.EActiveView.Agreement, {
          prevView: view.active,
          prevData: view.data
        }));
      } else {
        dispatch({
          type: _action_types.PHONE_AUTH_REGISTER_OR_AUTHORIZE_BY_TOKEN_TYPE,
          status: _phoneAuth.ERegisterOrAuthByTokenStatus.Failed,
          error: res.response.message
        });
        dispatch((0, _view.changeView)(_.EActiveView.AccountSelectError));
      }
    } catch (e) {
      dispatch({
        status: _phoneAuth.ERegisterOrAuthByTokenStatus.Failed,
        type: _action_types.PHONE_AUTH_REGISTER_OR_AUTHORIZE_BY_TOKEN_TYPE,
        error: 'Произошла непредвиденная ошибка'
      });
      dispatch((0, _view.changeView)(_.EActiveView.AccountSelectError));
      context.logger.error(e, {
        domain: 'auth-widget.api.registerOrAuthorizeByToken'
      });
    }
  };
}